export enum SubScope {
    Direct = "Direct",
    Induced = "Induced",
    SupplyChain = "Supply Chain",
    FinanceEnabling = "Finance enabling",
    PowerEnabling = "Power Enabling",
}
